import React from 'react';
import { Ticket, Lock } from 'lucide-react';
import { formatCOP } from '@/utils/format';

export const MyCouponsPicker = ({ coupons, subtotal, onPick, disabled }) => {
  if (!coupons || coupons.length === 0) return null;

  return (
    <div className="mt-3" data-testid="checkout-my-coupons">
      <p className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-[#8BA58F] font-semibold mb-2">
        <Ticket className="w-3.5 h-3.5" /> Tus cupones
      </p>
      <div className="flex flex-col gap-2">
        {coupons.map((c) => {
          const locked = c.min_purchase > subtotal;
          const missing = locked ? c.min_purchase - subtotal : 0;
          const label = c.discount_type === 'percentage' ? `${c.discount_value}%` : formatCOP(c.discount_value);
          return (
            <button
              key={c.code}
              type="button"
              disabled={disabled || locked}
              onClick={() => onPick(c.code)}
              title={locked ? `Te faltan ${formatCOP(missing)} para usarlo` : `Aplicar ${c.code}`}
              className={`w-full flex items-center justify-between gap-3 rounded-xl border px-3 py-2 text-left transition-colors ${
                locked
                  ? 'border-[#E7E5E4] bg-[#FAFAF9] text-[#A8A29E] cursor-not-allowed'
                  : 'border-dashed border-[#2A5C43] bg-white hover:bg-[#F0F5EF] text-[#1C1917]'
              }`}
              data-testid={`checkout-pick-coupon-${c.code}`}
            >
              <span className="min-w-0">
                <span className="block text-sm font-bold tracking-wider truncate">{c.code}</span>
                <span className={`block text-[11px] ${locked ? 'text-[#A8A29E]' : 'text-[#57534E]'}`}>
                  {locked ? `Te faltan ${formatCOP(missing)} (mínimo ${formatCOP(c.min_purchase)})` : c.min_purchase > 0 ? `Mínimo ${formatCOP(c.min_purchase)}` : 'Sin mínimo de compra'}
                </span>
              </span>
              <span className={`shrink-0 inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2.5 py-1 ${locked ? 'bg-[#E7E5E4] text-[#78716C]' : 'bg-[#2A5C43] text-white'}`}>
                {locked && <Lock className="w-3 h-3" />}-{label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
